import { useEffect, useState } from 'react';

// Service
import AdjustmentTypesService from '../../services/adjustmentTypes';

const useAdjustmentTypes = (filters) => {
    const [adjustmentTypes, setAdjustmentTypes] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const GetadjustmentTypes = () => {
            setLoading(true);
            AdjustmentTypesService
                .SearchAdjustmentTypes( 100, 1, filters)
                .then(res => setAdjustmentTypes(res.values))
                .finally(setLoading(false))
        }
        if (!loading && (!adjustmentTypes || adjustmentTypes.length === 0))
            GetadjustmentTypes();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters])

    const clear = () => 
        setAdjustmentTypes([])

    return {
        loading,
        adjustmentTypes,
        clear
    }
}

export default useAdjustmentTypes;